import base from "../baseurl";
import token from "../getTk";

const showAll = async (state) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const show = await api
    .post("company-form-campaigns/create", {
      json: {
        name: state.name,
        formsData: [
          {
            users: [],
            formId: state.formId,
            companies: state.companies.map((comp) => comp.id),
          },
        ],
        enabled: true,
      },
    })
    .json();
  return show;
};

export default showAll;
